<template>
  <div class="whole-div-MFP" @click="handleClick">
    <!--    第一层-->
    <div class="div1-MFP">
      <swiper ref="mySwiper" :options="swiperOptions" style="width: 100%;height: 100%">
        <swiper-slide v-for='(item, index) in swiperList' :key='index'>
          <img :src="item.src" title="畜禽无害化智能处理机" alt="" width="100%" height="100%">
        </swiper-slide>
      </swiper>
    </div>

    <!--    第四层：关于我们标签-->
    <div class="div4-MFP" style="background-color: whitesmoke;">
      <a class="div2-a1-MFP">
        <a class="div2-a1-a1-MFP" style="color: blueviolet"><i>About us/<strong>关于我们</strong></i></a>
        <br>
        一家从事畜禽无害化处理设备生产经营的专业化公司
      </a>
    </div>
    <!--    第五层：关于我们内容-->
    <div class="div5-MFP">
      <div class="div3-div1-MFP">
        <img :src="companyImg" title="浙江纵海自动化设备有限公司" width="95%">
      </div>
      <div class="div3-div1-MFP">
        <a class="div3-a1-MFP">浙江纵海自动化设备有限公司</a><br><br>
      </div>
      <div class="div3-div1-MFP">
        <a class="div3-a2-MFP">&#12288;&#12288;{{companyDetails1}}</a>
      </div>
      <div class="div3-div1-MFP">
        <a class="div3-a2-MFP">&#12288;&#12288;{{companyDetails2}}</a>
      </div>
      <div class="div3-div2-MFP">
        <el-button type="primary" @click="routing('关于我们')">查看更多</el-button>
        <el-button style="margin-left: 30px" type="info" @click="openConsult">立即咨询</el-button>
      </div>
      <div class="div5-div6-MFP">
        <div class="div5-div6-div1-MFP" @click="routing('公司介绍')">
          <a><img :src="companyIntroduceImg" width="90%" style="cursor: pointer;"></a>
          <br>
          <a style="cursor: pointer;">公司介绍</a>
        </div>
        <div class="div5-div6-div2-MFP" @click="routing('荣誉资质')">
          <a><img :src="honorImg" width="90%" style="cursor: pointer;"></a>
          <br>
          <a style="cursor: pointer;">荣誉资质</a>
        </div>
        <div class="div5-div6-div2-MFP" @click="routing('联系我们')">
          <a><img :src="contactUsImg" width="90%" style="cursor: pointer;"></a>
          <br>
          <a style="cursor: pointer;">联系我们</a>
        </div>
      </div>
    </div>

    <!--   第二层:我们的业务 -->
    <div class="div2-MFP">
      <a class="div2-a1-MFP">
        <a class="div2-a1-a1-MFP">Our business/<strong>我们的业务</strong></a>
        <br>
        致力于畜禽无害化处理设备与废气、废水处理设备的研发与生产
      </a>
    </div>

    <!--  第三层：产品中心的内容-->
    <div class="div3-MFP">
      <div class="div3-div1-MFP">
        <img :src="productImg" title="畜禽无害化智能处理机" width="95%">
      </div>
      <div class="div3-div1-MFP">
        <a class="div3-a1-MFP">畜禽无害化智能处理机</a><br><br>
      </div>
      <div class="div3-div1-MFP">
        <a class="div3-a2-MFP">&#12288;&#12288;{{productDetails}}</a>
      </div>
      <div class="div3-div2-MFP">
        <el-button type="primary" @click="routing('产品中心')">查看更多</el-button>
        <el-button style="margin-left: 30px" type="info" @click="openConsult">立即咨询</el-button>
      </div>
    </div>

    <!--   第六层：新闻中心 -->
    <div class="div2-MFP" style="background-color:lightgrey">
      <a class="div2-a1-MFP">
        <a class="div2-a1-a1-MFP" style="color: brown">News Center/<strong>新闻中心</strong></a>
        <br>
        一家从事畜禽无害化处理设备生产经营的专业化公司
      </a>
    </div>

    <!--第七层：新闻中心内容-->
    <div class="div7-MFP">
      <div class="div7-div1-MFP">
        <a class="div7-a1-MFP">
          <button style="padding: 5px" @click="routing('新闻中心')">点击查看更多...</button>
        </a>
      </div>
      <div class="div7-div2-MFP">
        <div class="div7-div2-div-MFP" @click="clickQuestion(item)" v-for="(item,index) in commonQuestionsLists" :key="index">
          <!--          标题+时间-->
          <div class="div7-div2-div1-div1-MFP">
            <a class="div7-div2-a1-MFP">{{item.title}}</a>
            <a class="div7-div2-a2-MFP">{{item.dateTime}}</a>
          </div>
          <!--          内容-->
          <div class="div7-div2-div1-div2-MFP">
            <a class="div7-div2-a3-MFP">{{item.details}}</a>
          </div>
          <!--          按钮：了解详情-->
          <div class="div7-div2-div1-div3-MFP">
            <div class="div7-div2-div1-div3-div-MFP">
              了解详情
            </div>
          </div>
        </div>
      </div>
    </div>

<!--    第八层：底框-->
    <div class="div9-MFP">
      <div class="div9-div1-MFP">
        <a class="div9-a1-MFP">联系人：{{this.$store.state.contactIntroduce.personName}}</a><br>
        <a class="div9-a1-MFP">联系方式：{{this.$store.state.contactIntroduce.phoneNumber}}</a><br>
        <a class="div9-a1-MFP">邮箱：{{this.$store.state.contactIntroduce.email}}</a><br>
        <a class="div9-a1-MFP">地址：{{this.$store.state.contactIntroduce.address}}</a><br>
      </div>
      <div class="div9-div2-MFP">
        <a class="div9-a2-MFP" href="https://beian.miit.gov.cn/" target="_blank">{{this.$store.state.contactIntroduce.recordNumber}}</a><br>
        <a class="div9-a2-MFP" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33108202000840" target="_blank">{{this.$store.state.contactIntroduce.policeRecordNumber}}</a><br>
      </div>
      <div class="div9-div2-MFP">
        <a style="font-family: Avenir">Copyright © 2024</a><br>
        <a >版权所有©浙江纵海自动化设备有限公司</a><br>
      </div>
      <div class="div9-div2-MFP">
        <a>声明:本站部分数据来源于互联网,与本公司无关,若有侵权请联系客服删除。</a>
      </div>
    </div>

  </div>
</template>

<script>
  import '../css/mobile/MFP_MobileFirstPage.css'
  import {Swiper, SwiperSlide} from 'vue-awesome-swiper';
  import 'swiper/css/swiper.css';

  export default {
    name: "MobileFirstPage",
    data() {
      return {
        //新闻中心列表
        //行业新闻总列表
        commonQuestionsLists: [{
          title: '强化病死动物无害化处理监管',
          dateTime: '2024-05-17',
          details: '2月19日我部和国务院食品安全办、食品药品监管总局联合引发了《国务院食品安全办、农业部、国家食品药品监督管理总局关于进一步加强病死动物及其产品监管工作的通知》（食安办[2014]5号）（以下简称“通知”）。各地要认真贯彻落实“通知”精神，切实强化病死动物无害化处理监管工作。要采取有效措施督促落实动物养殖、屠宰等生产经营者主体责任。推动辖区内病死动物无害化处理场所所统筹规划、设施设备建设完善工作。上海、浙江、江苏、安徽、江西等水网密集省份要立即开展拉网式排查，坚决杜绝“黄浦江漂浮死猪”类似事件再次发生，要积极配合有关部门，强化执法检查，加强联防联控，严防病死动物产品流入市场和餐桌。',
        }, {
          title: '如何判断哪些畜禽和畜禽产品应当进行无害化处理',
          dateTime: '2024-05-17',
          details: '染疫或者疑似疫死亡、因病死亡或者死因不明的；经检疫、检验可能危害人体或者动物健康的；因自然灾害、应激反应、物理挤压等因素死亡的；屠宰过程中经肉品品质检验确认为不可食用的；死胎、木乃伊胎等；因动物疫病防控需要被扑杀或销毁的；其他应当进行无害化处理的。',
        }, {
          title: '对病害畜禽产品进行贮存和清运的要求',
          dateTime: '2024-05-17',
          details: '（一）采取必要的冷藏冷冻、清洗消毒等措施；\n' +
            '（二）具有病死畜禽和病害畜禽产品专用输出通道；\n' +
            '（三）及时通知病死畜禽无害化处理场进行收集，或自行送至指定地点。',
        }, {
          title: '畜禽无害化处理的详细说明',
          dateTime: '2024-05-17',
          details: '（一）病死畜禽和病害畜禽产品无害化处理以集中处理为主，自行处理为补充。\n' +
            '（二）畜禽养殖场、屠宰厂（场）、隔离场在本场（厂）内自行处理病死畜禽和病害畜禽产品的，应当符合无害化处理场所的动物防疫条件，不得处理本场（厂）外的病死畜禽和病害畜禽产品。\n' +
            '（三）对于边远和交通不便地区以及畜禽养殖户自行处理零星病死畜禽的，省级人民政府农业农村主管部门可以结合实际情况和风险评估结果，组织制定相关技术规范。\n' +
            '（四）鼓励在符合国家有关法律法规规定的情况下，对病死畜禽和病害畜禽产品无害化处理产物进行资源化利用。病死畜禽和病害畜禽产品无害化处理场所销售无害化处理产物的，应当严控无害化处理产物流向，查验购买方资质并留存相关材料，签订销售合同。\n' +
            '（五）病死畜禽和病害畜禽产品无害化处理应当符合安全生产、环境保护等相关法律法规和标准规范要求，接受有关主管部门监管。病死畜禽无害化处理场处理本办法第三条之外的病死动物和病害动物产品的，应当要求委托方提供无特殊风险物质的证明。',
        },],
        //产品图片,内容
        productImg: require('../../public/image/产品1.jpg'),
        productDetails: '畜禽无害化智能处理机,对病死畜禽及其制品主要采取干化法分类进行无害化处理，通过高温裂解，将病原体完全杀灭，并使油脂融化和蛋白质凝固，经化制后的油脂可用于工业用油； 肉骨粉可用于有机肥料加工的原材料。',
        //公司图片
        companyImg: require('../../public/image/公司3.jpg'),
        companyDetails1: '浙江纵海自动化设备有限公司，是一家从事环保设备、无害化处理设备生产经营的专业化公司。致力于畜禽无害化处理设备与废气、废水处理设备、粪便处理设备的研发与生产。',
        companyDetails2: '公司拥有10000余平方米标准生产厂区，配备完善的基地设施与设备，公司现有技术研发人员及高级技工20余人，涵盖设计、安装、调试、机械、电器、计算机、培训等领域。拥有国内先进水平的等离子切割设备、数控加工设备及自动化生产配套设备20余台套。',
        //荣誉资质，企业文化，联系我们
        honorImg: require('../../public/image/荣誉资质.jpg'),
        companyIntroduceImg: require('../../public/image/公司介绍.jpg'),
        contactUsImg: require('../../public/image/联系我们.jpg'),
        //
        product: {
          productImage: require('../../public/image/产品1.jpg'),
          productName: "畜禽无害化处理设备",
        },
        productImgSwiperOptions: {
          // 自动切换
          autoplay: {
            delay: 3000, //时间间隔
            disableOnInteraction: false, //*手动操作轮播图后不会暂停*
          },
          // 环路
          loop: true,
          // 前进后退按钮
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          // 分页器
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          // 切换效果cube
          effect: 'coverflow',
        },
        //第一层div：option方法
        swiperOptions: {
          // 自动切换
          autoplay: {
            delay: 3000, //时间间隔
            disableOnInteraction: false, //*手动操作轮播图后不会暂停*
          },
          // 环路
          loop: true,
          // 前进后退按钮
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          // 分页器
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          // 切换效果cube
          effect: 'cube',
          cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 40,
            shadowScale: 0.9
          },
        },
        swiperList: [{
          title:'畜禽无害化智能处理机',
          src: require('../../public/image/首页图片1.jpg'),
        },{
          title:'畜禽无害化智能处理机',
          src: require('../../public/image/首页图片2.jpg'),
        },{
          title:'畜禽无害化智能处理机',
          src: require('../../public/image/首页图片3.jpg'),
        },],
      }
    },
    mounted() {

    },
    components: {
      Swiper,
      SwiperSlide
    },
    methods: {
      // 打开咨询弹出框
      openConsult() {
        this.$store.state.mobileShowConsult = true;
      },
      //路由导向
      routing(flagString){
        if(flagString==='关于我们'){
          this.$router.push({path:'/MobileAboutUs'});
        }else if(flagString==='联系我们'){
          this.$router.push({path:'/MobileContactUs'});
        }else if(flagString==='公司介绍'){
          this.$router.push("/MobileAboutUs");
        }else if(flagString==='荣誉资质'){
          this.$router.push("/MobileHonorQualification");
        }else if(flagString==='产品中心'){
          this.$router.push("/MobileProductCenter");
        }else if(flagString==='新闻中心'){
          this.$router.push("/MobileNewsCenter");
        }else{
          this.$message({
            message:"操作失败",
            type:'error',
          })
        }
      },
      //问题点击
      clickQuestion(item){
        //赋值
        this.$store.state.questionIntroduce=item;
        this.$router.push({path:'/MobileQuestionIntroduce'})
      },
      //案例展示
      handleClick() {
        let that = this;
        if(that.$store.state.isShowNav==true){
          that.$store.state.isShowNav = false;
        }
      }
    },
  }
</script>

<style>

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
</style>



// WEBPACK FOOTER //
// src/mobile/MobileFirstPage.vue